var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{attrs:{"title":"Impressão do agendamento de exames","type":"fieldset"}},[_c('Form',{attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }